











import { Component, Prop, Vue, Mixins } from 'vue-property-decorator'

@Component({
	name: 'ErrorPage',
	components: {},
})
export default class ErrorPage extends Vue {
	private get msg() {
		return this.$route.query.error || '服务器异常'
	}
}
